import React from "react";
import { Button } from "../../../../../shadcn/components/ui/button";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

interface NoPropertiesToBidCardProps {
  hasUpcomingEvents?: boolean;
}

export default function NoPropertiesToBidCard({
  hasUpcomingEvents = false,
}: NoPropertiesToBidCardProps) {
  const router = useRouter();
  const portalAccessType = useSelector((state: any) => {
    return state.bidderAuth.portalAccessType;
  });
  const onlySwissEventUser = portalAccessType === "swiss";
  return (
    <div
      className={`pl-4 pr-4 md:pr-0 md:pl-5 pt-8 pb-8 md:pb-0 w-full bg-white`}
    >
      <div className="w-full lg:hidden">
        <img
          src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
            process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
              ? "27f785cc-24cb-4531-9b91-4a6c58bfaf37"
              : "771263b2-a630-46f2-ae99-24cece88c4be"
          }`}
          className="w-full h-[250px] object-cover"
          alt="property img"
        />
      </div>
      <div className="font-semibold font-sans mt-4 md:mt-0 text-lg xl:text-xl">
        {hasUpcomingEvents
          ? "Get Ready to Bid and Win!"
          : "No properties to bid on?"}
      </div>
      <div className="md:flex gap-4 xl:gap-5 justify-between mt-3">
        <div className="md:flex md:flex-col justify-between md:max-w-[160px]">
          <div className="text-xs font-sans text-brand-textGrey mb-8 lg:mb-0">
            Explore properties you like and start bidding
          </div>
          <Button
            disabled={onlySwissEventUser}
            className="w-full font-sans text-xs md:h-8 my-0 md:my-4 lg:my-0"
            onClick={() => {
              router.push(`/all-events`);
            }}
          >
            Explore{" "}
          </Button>
        </div>
        <div className="border border-transparent hidden lg:block">
          <img
            src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
              process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
                ? "27f785cc-24cb-4531-9b91-4a6c58bfaf37"
                : "771263b2-a630-46f2-ae99-24cece88c4be"
            }`}
            className="w-[150px] xl:w-[190px] h-[100px] xl:h-[130px] object-fill"
            alt="property img"
          />
        </div>
      </div>
    </div>
  );
}
